// @flow
import Enum from '@rover/react-lib/types/Enum';

export default class NavBarTheme extends Enum<string> {
  static TRANSPARENT = new NavBarTheme('transparent');
  static OPAQUE = new NavBarTheme('opaque');
  static isLocked = true;

  isTransparent(): boolean {
    return this.value === 'transparent';
  }
}



// WEBPACK FOOTER //
// ../react-lib/src/styles/NavBarTheme.js